// @ts-nocheck

import videoLayout from './videoLayout'
import { getByCompId, querySelector } from '@wix/thunderbolt-dom-utils'

function wixVideoWrapper(WixElement, services, environmentConsts): any {
	class wixVideo extends WixElement {
		constructor() {
			super()
		}

		connectedCallback() {
			if (environmentConsts.disableImagesLazyLoading) {
				this.reLayout()
			} else {
				services.intersectionObserver.observe(this)
			}
		}

		disconnectedCallback() {
			this.unobserveResize()
			this.unobserveIntersect()
			this.unobserveChildren()
		}

		unobserveIntersect() {
			services.intersectionObserver?.unobserve(this)
		}

		reLayout() {
			const {
				isVideoDataExists,
				videoWidth,
				videoHeight,
				qualities,
				videoId,
				videoFormat,
				alignType,
				fittingType,
				focalPoint,
				hasBgScrollEffect,
				autoPlay,
				animatePoster,
				containerId,
				isEditorMode,
				playbackRate,
				hasAlpha,
			} = JSON.parse(this.dataset.videoInfo)
			if (!isVideoDataExists) {
				return
			}

			const autoPlayAllowed = !environmentConsts.prefersReducedMotion && autoPlay

			const videoNode = this.querySelector(`video[id^="${containerId}"]`)
			const poster = this.querySelector(`.bgVideoposter[id^="${containerId}"]`)

			// if observed for missing video/poster, first cleanup, otherwise it's a noop
			this.unobserveChildren()

			if (!(videoNode && poster)) {
				this.observeChildren(this)
				return
			}

			const container = getByCompId(containerId, {
				document: this.getRootNode() as Document,
				experiments: environmentConsts.experiments,
				logger: environmentConsts.logger,
			})
			const canvas = querySelector(`.webglcanvas[id^="${containerId}"]`, {
				element: container,
				experiments: environmentConsts.experiments,
				logger: environmentConsts.logger,
			})
			const hasThunderBoltCanvas = hasAlpha || container.dataset.hasAlpha === 'true'

			if (hasThunderBoltCanvas && !canvas) {
				requestAnimationFrame(() => this.reLayout())
				return
			}

			services.mutationService.measure(() => {
				const measures = videoLayout.measure(videoNode, container, {
					hasBgScrollEffect,
					videoWidth,
					videoHeight,
					fittingType,
					alignType,
					qualities,
					staticVideoUrl: environmentConsts.staticVideoUrl,
					videoId,
					videoFormat,
					focalPoint,
				})

				const { videoSourceUrl, needsSrcUpdate, videoStyle } = measures
				services.mutationService.mutate(() => {
					videoLayout.mutate(
						poster,
						canvas,
						videoNode,
						videoStyle,
						autoPlayAllowed,
						videoSourceUrl,
						needsSrcUpdate,
						animatePoster,
						videoFormat,
						playbackRate,
						isEditorMode
					)
				})
			})
		}

		attributeChangedCallback(name, oldValue) {
			if (oldValue) {
				this.reLayout()
			}
		}

		static get observedAttributes() {
			return ['data-video-info']
		}
	}

	return wixVideo
}

export { wixVideoWrapper }
